import {useLazyQuery, useMutation} from '@apollo/client';
import {
  CHANGE_USER_GROUP,
  DEFAULT_PERMISSIONS,
  GET_STAFF_DATA,
  UPDATE_USER_PERMISSIONS,
} from './permissionsAuditPageQueries';
import {
  GetDefaultPermissions,
  GetDefaultPermissionsVariables,
} from '../../schema-types/GetDefaultPermissions';
import {
  ChangeUserGroup,
  ChangeUserGroupVariables,
} from '../../schema-types/ChangeUserGroup';
import {
  UpdateUserPermissions,
  UpdateUserPermissionsVariables,
} from '../../schema-types/UpdateUserPermissions';
import {GetStaffData, GetStaffDataVariables} from '../../schema-types/GetStaffData';

export const useStaffPermissions = () => {
  const [getDefault] = useMutation<GetDefaultPermissions, GetDefaultPermissionsVariables>(
    DEFAULT_PERMISSIONS
  );
  const [changeGroup, {data: groupData, loading: groupLoading}] = useMutation<
    ChangeUserGroup,
    ChangeUserGroupVariables
  >(CHANGE_USER_GROUP);
  const [updatePermissions, {data: permissionsData, loading: permissionsLoading}] =
    useMutation<UpdateUserPermissions, UpdateUserPermissionsVariables>(
      UPDATE_USER_PERMISSIONS
    );
  const [updatedStaff, {data: staffData, loading: staffLoading}] = useLazyQuery<
    GetStaffData,
    GetStaffDataVariables
  >(GET_STAFF_DATA, {
    fetchPolicy: 'network-only',
  });

  return {
    getDefault,
    changeGroup,
    groupData,
    updatePermissions,
    permissionsData,
    groupLoading,
    permissionsLoading,
    updatedStaff,
    staffData,
    staffLoading,
  };
};
